/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Attendance_State_NoInputs */

const en_interview_attendance_state_no = /** @type {(inputs: Interview_Attendance_State_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marked as not attended`)
};

const de_interview_attendance_state_no = /** @type {(inputs: Interview_Attendance_State_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als nicht wahrgenommen markiert`)
};

/**
* | output |
* | --- |
* | "Marked as not attended" |
*
* @param {Interview_Attendance_State_NoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interview_attendance_state_no = /** @type {((inputs?: Interview_Attendance_State_NoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Attendance_State_NoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_attendance_state_no(inputs)
	return en_interview_attendance_state_no(inputs)
});